declare global {
  interface Window {
    SwiperElementRegisterParams?: any;
  }
}

if (typeof window !== "undefined" && window.SwiperElementRegisterParams) {
  window.SwiperElementRegisterParams(["materialEffect"]);
}

function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    // prevent bug disable gallery item hover animation
    if (el.classList.contains("hover-active")) {
      const materialImage = el.querySelector(".material-image");
      if (materialImage !== null) {
        materialImage.style.removeProperty("transition-duration");
      }
    }
    el.removeEventListener("transitionend", fireCallBack);
  }
  if (callback) {
    el.addEventListener("transitionend", fireCallBack);
  }
}

function effectVirtualTransitionEnd({ swiper, duration, transformElements, allSlides }) {
  const { activeIndex } = swiper;
  const getSlide = (el) => {
    if (!el.parentElement) {
      // assume shadow root
      const slide = swiper.slides.filter((slideEl) => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
      return slide;
    }
    return el.parentElement;
  };
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    if (allSlides) {
      transitionEndTarget = transformElements;
    } else {
      transitionEndTarget = transformElements.filter((transformEl) => {
        const el = transformEl.classList.contains("swiper-slide-transform")
          ? getSlide(transformEl)
          : transformEl;
        return swiper.getSlideIndex(el) === activeIndex;
      });
    }
    transitionEndTarget.forEach((el) => {
      elementTransitionEnd(el, () => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true,
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}

export default function EffectMaterial({ swiper, on }) {
  const slideSplitRatio = 0.65;
  const elementScale = 1.25;

  const setTransition = (duration) => {
    const { slides } = swiper;
    const transformElements = [];
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const materialEl = slideEl.querySelector(".material-wrapper");
      const scaleEls = slideEl.querySelectorAll(".material-image");

      [materialEl, ...scaleEls].forEach((opacityEl) => {
        opacityEl.style.transitionDuration = `${duration}ms`;
      });

      transformElements.push(materialEl);
    }

    effectVirtualTransitionEnd({ swiper, duration, transformElements, allSlides: true });
  };

  const setTranslate = () => {
    const { slides, slidesSizesGrid, params, size: swiperSize } = swiper;
    const { slidesPerView, spaceBetween, cssMode, centeredSlides } = params;
    const largeSlideRatio = centeredSlides
      ? 0.5
      : Math.min(Math.max(slideSplitRatio, 0), 1);
    const smallSlideRatio = centeredSlides
      ? 0.5
      : 1 - Math.min(Math.max(slideSplitRatio, 0), 1);
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const materialEl = slideEl.querySelector(".material-wrapper");
      const scaleEl = slideEl.querySelector(".material-image");
      const progress = -slideEl.progress;
      const offset = slideEl.swiperSlideOffset;
      const swiperTranslate = swiper.translate;
      let scale;
      let translate = 0;
      const currentSlideSize = slidesSizesGrid[i];
      const scaleDiff =
        smallSlideRatio === 0 && !centeredSlides
          ? 0
          : spaceBetween / 2 / currentSlideSize;
      const cssModeTranslateOffset = cssMode ? swiperTranslate : 0;
      const isCenteredOdd = centeredSlides && slidesPerView % 2 === 1;
      const isCenteredEven = centeredSlides && slidesPerView % 2 === 0;

      // if (i === 0) {
      //   console.log("progress: ", progress);
      // }

      // for slides go outside to left <- (negative progress)
      if (progress <= 0) {
        // console.log("if progress <= 0 i: ", i);
        // SLIDES BEFORE ACTIVE SLIDE / PREVIOUS
        if (centeredSlides && slidesPerView > 1) {
          // CENTERED/ACTIVE SLIDES
          if (progress <= 0 && progress >= -(slidesPerView - 2)) {
            translate = swiperTranslate;
            scale = 1;
          }

          // current to zero
          if (isCenteredOdd && progress < -(slidesPerView - Math.ceil(slidesPerView / 2))) {
            const currentProgress = Math.ceil(slidesPerView / 2) - Math.abs(progress);
            scale = currentProgress;
            translate = swiperTranslate + currentSlideSize * (1 - currentProgress) * (1 + scaleDiff * 2);
          }
          // current to large
          if (isCenteredEven && progress < -(slidesPerView / 2 - 1) && progress >= -(slidesPerView / 2)) {
            const currentProgress = slidesPerView / 2 - Math.abs(progress);
            scale = largeSlideRatio - scaleDiff + (smallSlideRatio + scaleDiff * 2) * (slidesPerView / 2 - Math.abs(progress));
            translate = swiperTranslate + currentSlideSize * (smallSlideRatio + scaleDiff) * (1 - currentProgress);
          }

          // large to zero
          if (isCenteredEven && progress < -slidesPerView / 2) {
            let currentProgress = slidesPerView / 2 + 1 - Math.abs(progress);
            // let translateAdd = 0;
            scale = 0;
            if (currentProgress >= 0) {
              currentProgress = -scaleDiff * 2 + currentProgress * (1 + scaleDiff * 2);
              currentProgress = Math.max(Math.min(currentProgress, 1), 0);
              scale = (smallSlideRatio - scaleDiff) * currentProgress;
            }
            translate = swiperTranslate + currentSlideSize * (smallSlideRatio + scaleDiff) * (2 - currentProgress) + currentSlideSize * (smallSlideRatio - scaleDiff) * (1 - currentProgress);
          }
        } else {
          // NOT CENTERED SLIDES
          scale = 1 + progress;
          translate = -offset;
        }
      }
      // for slides go outside to left <- (negative progress) END

      // for mobile view, TODO return default settings (slidesPerView === 1)
      if (slidesPerView === 1) {
        if (progress > 0) {
          scale = 1 - progress;
          translate = -offset + swiperSize * Math.min(progress, 1);
        }
      }
      
      // for desktop view
      if (slidesPerView !== 1) {
        const visibleActiveSlides = progress > 0 && progress <= slidesPerView - 2;
        const firstAfterActiveSlides = isCenteredEven
          ? progress > slidesPerView / 2 - 1 && progress <= slidesPerView / 2
          : progress > slidesPerView - 2 && progress <= slidesPerView - 1;

        const secondAfterActiveSlides = progress > slidesPerView - 1 && progress <= slidesPerView && !centeredSlides;
        const thirdAfterActiveSlides = progress > (centeredSlides ? slidesPerView / 2 : slidesPerView) && !isCenteredOdd;

        // visible active slides (not for slide going outside, inside)
        if (visibleActiveSlides) {
          translate = swiperTranslate;
          scale = 1;
        }
        // 0.65 -> 1
        if (firstAfterActiveSlides) {
          const minus = isCenteredEven ? Math.floor(slidesPerView / 2) : 1;
          scale = largeSlideRatio - scaleDiff + (smallSlideRatio + scaleDiff * 2) * (slidesPerView - minus - Math.abs(progress));
          translate = swiperTranslate;
        }

        // 0.35 -> 0.65
        if (secondAfterActiveSlides) {
          const currentProgress = slidesPerView - Math.abs(progress);
          const largeWithDiff = largeSlideRatio - scaleDiff;
          const smallWithDiff = smallSlideRatio - scaleDiff;
          scale = smallWithDiff + (largeWithDiff - smallWithDiff) * currentProgress;
          translate = swiperTranslate - currentSlideSize * (smallSlideRatio + scaleDiff) * (1 - currentProgress);
        }
        // 0 -> 0.35
        if (thirdAfterActiveSlides) {
          let currentProgress = (centeredSlides ? slidesPerView / 2 + 1 : slidesPerView + 1) - Math.abs(progress);
          let translateAdd = 0;
          scale = 0;
          if (currentProgress >= 0) {
            currentProgress = -scaleDiff * 2 + currentProgress * (1 + scaleDiff * 2);
            currentProgress = Math.max(Math.min(currentProgress, 1), 0);
            scale = (smallSlideRatio - scaleDiff) * currentProgress;
            translateAdd = -currentProgress * (smallSlideRatio + scaleDiff) * currentSlideSize + currentProgress * spaceBetween;
          }
          translate = -offset + swiperSize * Math.min(progress, 1) + translateAdd;
        }
      }

      if (scale < 0) {
        scale = 0;
      }
      if (scale > 1) {
        scale = 1;
      }
      // if (scale === 0) {
      //   scale = 0.0001;
      // }
      
      // prevent round problem
      if ((scale < 1 && scale > 0.9) || (scale > 1 && scale < 1.1)) {
        scale = 1;
      }

      slideEl.style.setProperty("--covet-material-scale", scale);
      
      if (scaleEl !== null) {
        // TODO check is it possible to refactor this
        if (scaleEl.classList.contains("material-image-translate")) {
          scaleEl.style.transform = `translate(-50%, -50%) scale(${1 + (elementScale - 1) * (1 - scale)})`;
        } else {
          scaleEl.style.transform = `scale(${1 + (elementScale - 1) * (1 - scale)})`;
        }
      }
      
      if (scale === 1) {
        materialEl.classList.add("hover-active");
        if (scaleEl !== null) {
          scaleEl.style.removeProperty("transform");
          // scaleEl.style.removeProperty("transition-duration"); // TODO temp disable, for enter scale in animation
        }
      } else {
        materialEl.classList.remove("hover-active");
      }
      materialEl.style.width = `${100 * scale}%`;
      materialEl.style.transform = `translate3d(${translate - cssModeTranslateOffset}px, 0, 0)`;
    }
  };

  on("setTranslate", () => {
    if (swiper.params.effect !== "material") return;
    setTranslate();
  });
  on("setTransition", (_s, duration) => {
    setTransition(duration);
  });
  on("slidesUpdated", () => {
    // add additional slide
    if (swiper.params.slidesPerView > 1) {
      const lastItem = swiper.snapGrid[swiper.snapGrid.length - 1];
      swiper.snapGrid.push(lastItem + swiper.slidesSizesGrid[0] + swiper.params.spaceBetween);
    }
    // TODO test solution basic-1,2,3,4,5,6 height issue
    if (swiper.el.classList.contains("extra-height")) {
      const descriptions = Array.from(swiper.el.querySelectorAll(".swiper-wrapper .swiper-slide .material-wrapper .description")) as [HTMLElement];
      const descriptionMaxHeight = descriptions.reduce((maxElem, currentElem) => {
        return maxElem.offsetHeight > currentElem.offsetHeight ? maxElem : currentElem;
      });
      swiper.el.style.setProperty("--material-slide-extra-height", `${descriptionMaxHeight.offsetHeight}px`);
    }
    // TODO test solution basic-1,2,3,4,5,6 height issue END
    swiper.el.style.setProperty("--material-slide-size", `${swiper.slidesSizesGrid[0]}px`);
  });

}